// src/Login.js
import React from 'react';
import './noAccess.css'; // Import the CSS file for styling

const NoAccess = () => {
    return (
            <div className="noaccess-container">
                <img src="/Group 19.png" alt="Description" className="centered-image" />
                 <h3>403 Title</h3>
                 <p>Sorry, you do not have access to the site. Reach out to your contact for access.</p>
            </div>
     );
};

export default NoAccess;
